// extracted by css-extract-rspack-plugin
export default {"metricExpressionPill":"qvapB","expressionText":"Vn5K9","editableName":"wlsgt"};